// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForwardMessagePopup__forward-message-footer-b7fca6 {
  height: auto;
  min-height: 72px;
}

.ForwardMessagePopup__forward-message-footer-b7fca6.ForwardMessagePopup__with-input-ca2333 {
  padding-top: 8px;
  padding-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ForwardMessagePopup/ForwardMessagePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;AACF","sourcesContent":[".forward-message-footer {\n  height: auto;\n  min-height: 72px;\n}\n\n.forward-message-footer.with-input {\n  padding-top: 8px;\n  padding-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forward-message-footer": `ForwardMessagePopup__forward-message-footer-b7fca6`,
	"forwardMessageFooter": `ForwardMessagePopup__forward-message-footer-b7fca6`,
	"with-input": `ForwardMessagePopup__with-input-ca2333`,
	"withInput": `ForwardMessagePopup__with-input-ca2333`
};
module.exports = ___CSS_LOADER_EXPORT___;
